import { orchestrator } from 'satcheljs';
import { manageDomainClick } from '../actions/manageDomainClick';
import { traceManageDomainButtonClick } from '../utils/domainOptionTracer';

let manageDomainUrl = 'https://go.microsoft.com/fwlink/?linkid=872355';

export default orchestrator(manageDomainClick, async function mangeDomainClick() {
    traceManageDomainButtonClick();
    window.open(manageDomainUrl, '_blank');
});
